module.exports = __webpack_public_path__ + "static/media/search-clipart.d983ef05.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/search-clipart.png
// module id = 92
// module chunks = 0